import React from 'react';
import NotificationComponent from './NotificationComponent';

const Notification = () => {
    return <NotificationComponent />;
};

export default Notification;
